<template>
  <div class="container">
    <div class="columns box-title is-12">
      <div class="column is-12">
        <h4 class="has-text-left">
          <i class="fal fa-cog"></i>
          ຕັ້ງຄ່າລະບົບ
        </h4>
      </div>
    </div>

    <div class="settings-shell">
      <!--
        Small in-page side menu. It exists so the settings sections that follow
        (this one is the first) get a home without adding a top-level sidebar
        entry each — the outer sidebar keeps one "ຕັ້ງຄ່າລະບົບ" item.
      -->
      <aside class="settings-menu">
        <button
            v-for="section in sections"
            :key="section.key"
            type="button"
            class="settings-menu-item"
            :class="{ 'is-active': section.key === activeKey }"
            @click="select(section.key)"
        >
          <i :class="section.icon"></i>
          <span>{{ section.label }}</span>
        </button>
      </aside>

      <section class="settings-content">
        <!--
          The menu array is the single source of which sections exist; a new section is one
          entry (key/label/icon/component) here, not a new v-else-if line.
        -->
        <component :is="activeSection.component" :key="activeSection.key"/>
      </section>
    </div>
  </div>
</template>

<script>
import ReturnRuleSettings from './ReturnRuleSettings';
import AutoSignExcludedBranches from './AutoSignExcludedBranches';
import DeliverySpeedTargets from './DeliverySpeedTargets';

const SECTIONS = [
  {
    key: 'return-rules',
    label: 'ຕັ້ງຄ່າ ການຕີກັບພັດສະດຸ',
    icon: 'fal fa-undo',
    component: ReturnRuleSettings,
  },
  /// Destination branches the nightly ສຳເລັດບິນ Auto must skip, optionally until a date.
  /// Its own section: the one above is day thresholds; this is a branch list.
  {
    key: 'auto-sign-excluded',
    label: 'ສາຂາ ບໍ່ສຳເລັດບິນ Auto',
    icon: 'fal fa-ban',
    component: AutoSignExcludedBranches,
  },
  /// The delivery targets the COO dashboard and its morning digest judge bills against.
  {
    key: 'delivery-speed-targets',
    label: 'ເປົ້າໝາຍຄວາມໄວການຈັດສົ່ງ',
    icon: 'fal fa-tachometer-alt',
    component: DeliverySpeedTargets,
  },
];

export default {
  name: 'SettingsPage',

  data() {
    return {
      sections: SECTIONS,
      /// Deep-linkable: `/settings?section=auto-sign-excluded` survives a reload and can be
      /// handed to IT. An unknown value falls back to the first section.
      activeKey: this.sectionKeyFromRoute(),
    };
  },

  computed: {
    activeSection() {
      return this.sections.find(section => section.key === this.activeKey) || this.sections[0];
    },
  },

  watch: {
    /// Browser back/forward between sections.
    '$route.query.section'() {
      this.activeKey = this.sectionKeyFromRoute();
    },
  },

  methods: {
    sectionKeyFromRoute() {
      const requested = this.$route && this.$route.query && this.$route.query.section;
      return SECTIONS.some(section => section.key === requested) ? requested : SECTIONS[0].key;
    },

    select(key) {
      if (key === this.activeKey) {
        return;
      }
      this.activeKey = key;
      /// replace, not push: switching panes is not a navigation the back button should replay.
      this.$router.replace({ query: { ...this.$route.query, section: key } }).catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.settings-shell {
  display: flex;
  align-items: flex-start;
  gap: 18px;
  margin-top: 6px;
}

.settings-menu {
  flex: 0 0 250px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 8px;
  position: sticky;
  top: 12px;
}

.settings-menu-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: 0;
  background: transparent;
  border-radius: 8px;
  padding: 11px 12px;
  font-family: inherit;
  font-size: 15px;
  color: #374151;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: #f3f4f6;
  }

  &.is-active {
    background: rgba(25, 91, 255, 0.1);
    color: #195BFF;
    font-weight: 600;
  }

  i {
    width: 18px;
    text-align: center;
  }
}

.settings-content {
  flex: 1 1 auto;
  min-width: 0;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px 18px;
}

@media screen and (max-width: 900px) {
  .settings-shell {
    flex-direction: column;
  }

  .settings-menu {
    flex: 1 1 auto;
    width: 100%;
    position: static;
    display: flex;
    gap: 6px;
    overflow-x: auto;
  }

  .settings-menu-item {
    width: auto;
    white-space: nowrap;
  }
}
</style>
